import { render, staticRenderFns } from "./DataSelection.vue?vue&type=template&id=2278f068&scoped=true"
import script from "./DataSelection.vue?vue&type=script&lang=js"
export * from "./DataSelection.vue?vue&type=script&lang=js"
import style0 from "./DataSelection.vue?vue&type=style&index=0&id=2278f068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278f068",
  null
  
)

export default component.exports